export interface CreationInfoDto {
  employeeId: string;
  employeeName?: string;
  date: string;
}

export enum Language {
  English = 1,
  Spanish = 2,
}

export enum InviteStateType {
  Pending = 1,
  Accepted = 2,
}

export enum ScheduledActivityType {
  'Schedule Call' = 11,
  'Follow Up' = 12,
  Call = 13,
  Text = 14,
  Email = 15,
  Reminder = 16,
  Other = 17,
  Snooze = 18,
}

export enum DwellingType {
  House = 1,
  Apartment = 2,
}

export enum ExtendedDwellingType {
  House = 1,
  Apartment = 2,
  Both = 3,
}

export interface EmployeeDto {
  id: string;
  name: string;
  phone?: string | null;
}

export interface ReferralSourceDto {
  email: string;
  contact: string;
  phone: string;
}

export interface CompanyDto {
  id: number;
  name: string;
  remarks?: string | null;
}

export interface LicenseeDto {
  id: number;
  name: string;
  code: string;
}

export interface EnumDto {
  name: string;
  id: number;
}
